/* eslint-disable import/prefer-default-export */
// app模块
export const APP_UPDATE_LOAING_STATUS = 'APP_UPDATE_LOAING_STATUS';
export const APP_FWLBBZ_LIST = 'APP_FWLBBZ_LIST';

// auth模块
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_SET_WXUSER = 'AUTH_SET_WXUSER';
export const AUTH_SET_USER = 'AUTH_SET_USER';

// topup模块
export const TOPUP_SET_ZHXX = 'TOPUP_SET_ZHXX';
export const TOPUP_SET_DZBM = 'TOPUP_SET_DZBM';
/*
  订单流水号
 */
export const TOPUP_SET_PAYKEY = 'TOPUP_SET_PAYKEY';
/*
当前订单信息
 */
export const TOPUP_SET_DQDD = 'TOPUP_SET_DQDD';



// WEBPACK FOOTER //
// ./src/store/types.js